import { Route } from '@angular/router'
import { abgabewegAuswahlGuard } from './phm/phm-abgabeweg/abgabeweg-auswahl.guard'

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./navigation/navigation.component').then((m) => m.NavigationComponent),
    title: 'Selfservice',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'phm/landing',
      },
      {
        path: '',
        loadComponent: () => import('./phm/phm-auth/phm-auth.component').then((m) => m.PhmAuthComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./components/whitelable-nav/whitelabel-nav.component').then((m) => m.WhitelabelNavComponent),
            children: [
              // redirect to overview if patient has already a pflegebox, otherwise to /phm
              {
                path: 'phm/landing',
                loadComponent: () => import('./phm/phm-landing/phm-landing.component').then((m) => m.PhmLandingComponent),
              },
              {
                path: 'phm/overview',
                loadComponent: () => import('./phm/phm-overview/phm-overview.component').then((m) => m.PhmOverviewComponent),
              },
              /* Anlage */
              {
                path: 'phm',
                loadComponent: () => import('./phm/phm-form/phm-form.component').then((m) => m.PhmFormComponent),
                // Der Abgabeweg entscheidet ueber das Sortiment — also darueber, welche Produkte
                // dieser Stepper ueberhaupt anbietet. Deshalb steht die Frage davor und nicht darin.
                // Der Guard laesst durch, wenn es nichts zu waehlen gibt.
                canActivate: [abgabewegAuswahlGuard],
              },
              {
                path: 'phm/auswahl/abgabeweg',
                loadComponent: () => import('./phm/phm-abgabeweg/phm-abgabeweg.component').then((m) => m.PhmAbgabewegComponent),
              },
              {
                // Sackgasse fuer ein Haus, das Pflegehilfsmittel gar nicht anbietet — der Guard
                // oben schickt hierher, statt die Patient:in in einen Stepper ohne Sortiment zu
                // lassen. Bewusst unter der Whitelabel-Navigation: Logo und Farben ihres Hauses
                // bleiben stehen, nur das Angebot fehlt.
                path: 'phm/nicht-angeboten',
                loadComponent: () =>
                  import('./phm/phm-nicht-angeboten/phm-nicht-angeboten.component').then((m) => m.PhmNichtAngebotenComponent),
              },
              {
                path: 'phm/digital-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-digital-success/phm-abschluss-digital-success.component').then(
                    (m) => m.PhmAbschlussDigitalSuccessComponent,
                  ),
                data: { insuranceType: 'GKV' },
              },
              {
                path: 'phm/analog-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-analog-success/phm-abschluss-analog-success.component').then(
                    (m) => m.PhmAbschlussAnalogSuccessComponent,
                  ),
                data: { insuranceType: 'GKV' },
              },
              {
                path: 'phm/pdf-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-pdf-success/phm-abschluss-pdf-success.component').then(
                    (m) => m.PhmAbschlussPdfSuccessComponent,
                  ),
                data: { insuranceType: 'GKV' },
              },
              {
                path: 'phm/email-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-email-success/phm-abschluss-email-success.component').then(
                    (m) => m.PhmAbschlussEmailSuccessComponent,
                  ),
                data: { insuranceType: 'GKV' },
              },
              {
                path: 'phm/pkv/digital-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-digital-success/phm-abschluss-digital-success.component').then(
                    (m) => m.PhmAbschlussDigitalSuccessComponent,
                  ),
                data: { insuranceType: 'PKV' },
              },
              {
                path: 'phm/pkv/analog-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-analog-success/phm-abschluss-analog-success.component').then(
                    (m) => m.PhmAbschlussAnalogSuccessComponent,
                  ),
                data: { insuranceType: 'PKV' },
              },
              {
                path: 'phm/pkv/pdf-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-pdf-success/phm-abschluss-pdf-success.component').then(
                    (m) => m.PhmAbschlussPdfSuccessComponent,
                  ),
                data: { insuranceType: 'PKV' },
              },
              {
                path: 'phm/pkv/email-abschluss',
                loadComponent: () =>
                  import('./phm/abschluss/phm-abschluss-email-success/phm-abschluss-email-success.component').then(
                    (m) => m.PhmAbschlussEmailSuccessComponent,
                  ),
                data: { insuranceType: 'PKV' },
              },
              /* Edit */
              {
                path: 'phm/edit/cart',
                loadComponent: () =>
                  import('./phm/phm-edit/phm-product-edit/phm-product-edit.component').then((m) => m.PhmProductEditComponent),
              },
              {
                path: 'phm/edit/patient',
                loadComponent: () =>
                  import('./phm/phm-edit/phm-stammdaten-edit/phm-stammdaten-edit.component').then((m) => m.PhmStammdatenEditComponent),
              },
              {
                path: 'phm/edit/pg51',
                loadComponent: () => import('./phm/phm-edit/phm-edit-pg51/phm-edit-pg51.component').then((m) => m.PhmEditPg51Component),
              },
              {
                path: 'phm/edit/pkv/pg51',
                loadComponent: () =>
                  import('./phm/phm-edit/phm-edit-pg51-pkv/phm-edit-pg51-pkv.component').then((m) => m.PhmEditPg51PkvComponent),
              },
              /* Dokumente */
              {
                path: 'documents/phm/success',
                loadComponent: () =>
                  import('./documents/document-sign-success-page/document-sign-success-page.component').then(
                    (m) => m.DocumentSignSuccessPageComponent,
                  ),
              },
              {
                path: 'documents/himi/success',
                loadComponent: () =>
                  import('./documents/document-sign-success-page/document-sign-success-page.component').then(
                    (m) => m.DocumentSignSuccessPageComponent,
                  ),
              },
              {
                // Die Bemusterung unterschreibt VOR der Versorgungsanlage — eigene Route, weil
                // Bemusterung und Versorgung serverseitig in getrennten Containern liegen und ihre
                // ids opake UUIDs sind. Ein gemeinsamer Pfad wäre der verbotene Try-Both-Fallback.
                path: 'documents/bemusterung/success',
                loadComponent: () =>
                  import('./documents/document-sign-success-page/document-sign-success-page.component').then(
                    (m) => m.DocumentSignSuccessPageComponent,
                  ),
              },
              {
                path: 'documents/bemusterung',
                loadComponent: () =>
                  import('./documents/document-sign-page/document-sign-page.component').then((m) => m.DocumentSignPageComponent),
                data: { documentType: 'bemusterung' },
              },
              {
                path: 'documents/phm',
                loadComponent: () =>
                  import('./documents/document-sign-page/document-sign-page.component').then((m) => m.DocumentSignPageComponent),
                data: { documentType: 'phm' },
              },
              {
                path: 'documents/himi',
                loadComponent: () =>
                  import('./documents/document-sign-page/document-sign-page.component').then((m) => m.DocumentSignPageComponent),
                data: { documentType: 'himi' },
              },
              /* Abholung */
              {
                // Ziel des QR-Codes auf dem Abholbeleg: GENAU EINE Lieferung quittieren (`d`), fuer alle
                // drei Vorgangsarten (`t`). Unter PhmAuthComponent wie die Signier-Seiten: der Link traegt
                // seit 2026-10-07 das Geburtsjahr (`b`) und oeffnet ohne Abfrage; fehlt es (unlesbares
                // Geburtsdatum), fragt PhmAuthComponent es ab.
                path: 'abholung',
                loadComponent: () =>
                  import('./abholung/abholung-quittieren/abholung-quittieren.component').then((m) => m.AbholungQuittierenComponent),
              },
            ],
          },
        ],
      },
      {
        // Oeffentliche Danke-Seite nach SEPA-Mandatserteilung (Stripe success_url). Bewusst NICHT unter
        // PhmAuthComponent — der Patient kommt per externem Stripe-Redirect und ist hier nicht eingeloggt.
        path: 'sepa/mandat-erteilt',
        loadComponent: () => import('./sepa/sepa-mandat-erteilt/sepa-mandat-erteilt.component').then((m) => m.SepaMandatErteiltComponent),
      },
      {
        path: 'not-found',
        loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
      {
        path: '**',
        loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
]
